import { useAuth } from '@/hooks/useAuth';

/**
 * A hidden copy of the sign-in email for the browser's password manager.
 *
 * A password field with no username field makes Chrome guess one, and it picks
 * the nearest text box above the password -- which put the email into a
 * student's Phone field and into the sidebar's menu search. Render this just
 * before any password field so the browser has the field it is looking for.
 */
export function SignInName() {
  const { user } = useAuth();
  return (
    <input
      type="email"
      name="username"
      autoComplete="username"
      value={user?.email ?? ''}
      readOnly
      hidden
    />
  );
}
